import { ApiErrorCodeEnum } from '@/enums';

type TApiErrorShape = {
	code?: unknown;
	errorCode?: unknown;
	internalCode?: unknown;
	statusCode?: unknown;
	internalMessage?: unknown;
	message?: unknown;
};

const apiErrorMessages: Partial<Record<ApiErrorCodeEnum, string>> = {
	[ApiErrorCodeEnum.INVESTOR_PERCENTAGE_LIMIT_EXCEEDED]:
		'Création impossible: la somme des pourcentages investisseurs dépasse la limite autorisée.',
	[ApiErrorCodeEnum.TRANSACTION_DELETE_ONLY_CURRENT_MONTH]:
		'Erreur: seules les transactions du mois en cours peuvent etre supprimées.',
	[ApiErrorCodeEnum.TRANSACTION_DELETE_INVESTOR_ID_REQUIRED]:
		"Erreur: l'identifiant investisseur est requis pour annuler le solde investisseur.",
	[ApiErrorCodeEnum.TRANSACTION_DELETE_ONLY_OWNER_CAN_DELETE]:
		'Erreur: seul le proprietaire de la transaction peut la supprimer.',
	[ApiErrorCodeEnum.LIVE_EVENT_INVALID_DATES]:
		"L'événement doit commencer dans le futur et durer au moins 1 heure.",
	[ApiErrorCodeEnum.LIVE_EVENT_OVERLAP]: 'Un autre événement est déjà prévu sur cette période.',
	[ApiErrorCodeEnum.LIVE_EVENT_NOT_SCHEDULED]: 'Cet événement a déjà commencé ou est terminé.',
	[ApiErrorCodeEnum.PROMO_CODE_TAKEN]: 'Ce code existe déjà. Un code reste réservé même quand son offre est terminée.',
	[ApiErrorCodeEnum.PROMO_CODE_LOCKED]: "Le code ou le compte d'une offre déjà utilisée ne peut plus changer.",
	[ApiErrorCodeEnum.PROMO_TARGET_UNKNOWN]: "Aucun membre n'a cet email.",
	[ApiErrorCodeEnum.PROMO_TARGET_BUSY]: 'Ce membre a déjà un code promo programmé ou actif sur ces dates.'
};

export const getApiErrorCode = (error: unknown): ApiErrorCodeEnum | undefined => {
	if (!error || typeof error !== 'object') {
		return undefined;
	}

	const normalizedError = error as TApiErrorShape;
	const rawCode = normalizedError.code ?? normalizedError.errorCode ?? normalizedError.internalCode ?? normalizedError.statusCode;

	const code = typeof rawCode === 'number' ? rawCode : Number(rawCode);

	if (Number.isNaN(code)) {
		return undefined;
	}

	return code as ApiErrorCodeEnum;
};

export const getApiErrorMessage = (error: unknown, fallbackMessage: string) => {
	const code = getApiErrorCode(error);

	if (code && code in apiErrorMessages) {
		return apiErrorMessages[code as keyof typeof apiErrorMessages] as string;
	}

	if (error && typeof error === 'object') {
		const normalizedError = error as TApiErrorShape;

		if (typeof normalizedError.internalMessage === 'string' && normalizedError.internalMessage.length > 0) {
			return normalizedError.internalMessage;
		}

		if (typeof normalizedError.message === 'string' && normalizedError.message.length > 0) {
			return normalizedError.message;
		}
	}

	return fallbackMessage;
};
